import React from 'react'
import * as styles from './FooterLink.module.css'

import { Link } from 'gatsby'

// TODO: refactor. This is basically a navlink with a description in it
// I could extract the functionality and just allow to inject styles which
// is pretty much the only thing that changes between both components

const FooterLink = ({ className, href, children, rel, target}) => {
  const external = href.startsWith('http')
  const classes = [styles.link]
  if (className) classes.push(className)
  const classNames = classes.join(' ')

  if (external)
    return (
      <li className={classNames}>
        <a {...{ href, rel, target }}>{children}</a>
      </li>
    )
  else
    return (
      <li className={`${styles.link} ${className}`}>
        <Link to={href} {...{ rel, target }}>
          {children}
        </Link>
      </li>
    )
}

export default FooterLink
